export default __webpack_public_path__ + "static/logo-alt-9715a98c606e31c46c5d1f73f63f3558.png";